import { render, staticRenderFns } from "./plan-your-trip.vue?vue&type=template&id=2fb73237&scoped=true&"
import script from "./plan-your-trip.vue?vue&type=script&lang=js&"
export * from "./plan-your-trip.vue?vue&type=script&lang=js&"
import style0 from "./plan-your-trip.vue?vue&type=style&index=0&id=2fb73237&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb73237",
  null
  
)

export default component.exports